<template>
  <div style="width: 100%; height: 100%">
    <div style="width: 100%; height: 100%" class="map"></div>
  </div>
</template>

<script>
import mapboxgl from "mapbox-gl"
import Geocoder from "@mapbox/mapbox-gl-geocoder"
import "@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css"
import LegendControl from "./LegendControl"

mapboxgl.accessToken = "pk.eyJ1IjoibmFycm93dHV4IiwiYSI6ImNpZnRnbzVzNDAxdnd0a20wdG91ZHphOWcifQ.o13TzVvrJVe2J_WriuuEIw"

export default {
  mounted() {
    this.map = new mapboxgl.Map({
      style: "mapbox://styles/narrowtux/ck21rfshm08gd1ctgox5nv06e/draft",
      container: this.$el.querySelector(".map")
    })
    this.geocoder = new Geocoder({
      mapboxgl: this.map,
      accessToken: mapboxgl.accessToken,
      placeholder: "PLZ, Ort oder Adresse",
      types: "place, postcode, address",
      countries: "de",
      marker: true
    })
    this.geocoder.addTo(this.map)
    this.legend = new LegendControl()
    this.map.addControl(this.legend)
  }
}
</script>

<style>
  
</style>


// WEBPACK FOOTER //
// src/components/Map.vue